import type {
  ScheduleMode,
  BackupSchedule,
  Condition,
  BackupPolicyType,
  ResourceType,
} from '@repo/api-gw-sdk';

import type { ResourcesScopeType } from '@/components/resourcesSelection/resourceSelectionDynamicViewer';
import type { Step } from '@/components/wizard/Step';

import { BackupPolicyConditionEditor } from './BackupPolicyConditionEditor';
import { BackupPolicyNameSelection } from './BackupPolicyNameSelection';
import { BackupPolicyResourcesList } from './BackupPolicyResourcesList';
import { BackupPolicySettings } from './BackupPolicySettings';

export interface BackupPolicyEditState {
  id: string;
  name: string;
  condition?: Condition;
  schedules?: BackupSchedule[];
  include: string[];
  exclude: string[];
  resourcesScopeType: ResourcesScopeType;
  mode: ScheduleMode;
  policyType: BackupPolicyType;
  resourceTypes?: ResourceType[];
}

export const EditBackupPolicyFlow: Step<BackupPolicyEditState> = {
  name: 'Name Selection',
  Component: BackupPolicyNameSelection,
  nonReturnable: true,
  next: [
    {
      name: 'Resource selection',
      Component: BackupPolicyConditionEditor,
      next: [
        {
          name: 'Resource list',
          Component: BackupPolicyResourcesList,
          next: [
            {
              name: 'Backup schedules',
              Component: BackupPolicySettings,
            },
          ],
        },
      ],
    },
  ],
};
